(function ($) {
	$(document).ready(function () {
		const top_sales = new Swiper(".swiper_topsales", {
			autoplay: {
				delay: 3500,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			speed: 500,
			loop: true,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				0: {
					slidesPerView: 2,
					spaceBetween: 12,
				},
				992: {
					slidesPerView: 4,
					spaceBetween: 28,
				},
			},
		});

		const logo_carousel = new Swiper(".swiper_logo", {
			autoplay: {
				delay: 3500,
				disableOnInteraction: false,
			},
			slidesPerView: "auto",
			spaceBetween: 30,
			loop: true,
			speed: 1000,
			breakpoints: {
				320: {
					slidesPerView: 3,
					spaceBetween: 10,
				},
				480: {
					slidesPerView: 3,
					spaceBetween: 10,
				},
				640: {
					slidesPerView: 4,
					spaceBetween: 30,
				},
			},
		});

		const swiper_3 = new Swiper(".swiper__3-3", {
			autoplay: {
				delay: 3500,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			loop: true,
			speed: 500,
			grabCursor: true,
			navigation: {
				nextEl: ".swiper__3-3-nextBtn",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				320: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				480: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				960: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
			},
		});

		const swiper_4 = new Swiper(".swiper__4-4", {
			autoplay: {
				enabled: true,
				delay: 0,
				pauseOnMouseEnter: false,
				disableOnInteraction: false,
			},
			loop: true,
			centeredSlides: true,
			navigation: false,
			noSwipingClass: "swiper-slide",
			slidesPerView: "auto",
			speed: 8000,
			breakpoints: {
				320: {
					spaceBetween: 20,
				},
				1025: {
					spaceBetween: 20,
				},
			},
		});

		const swiper__5 = new Swiper(".swiper__5-5", {
			autoplay: {
				enabled: true,
				delay: 3500,
				pauseOnMouseEnter: true,
				disableOnInteraction: false,
			},
			speed: 500,
			loop: true,
			pagination: {
				el: ".swiper__5 .swiper-pagination",
				type: "bullets",
				clickable: true,
			},
			slidesPerView: 2,
			spaceBetween: 12,
			breakpoints: {
				1025: {
					slidesPerView: 6,
					spaceBetween: 30,
				},
			},
		});

		

		const original_gift = new Swiper(".swiper_original", {
			autoplay: {
				delay: 3500,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			loop: true,
			speed: 500,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			pagination: {
				el: ".swiper-pagination",
				type: "progressbar",
				renderProgressbar: function (progressbarFillClass) {
					return '<span class="' + progressbarFillClass + '"></span>';
				}
			},
			breakpoints: {
				0: {
					slidesPerView: 2,
					spaceBetween: 10,
				},
				992: {
					slidesPerView: 4,
					spaceBetween: 10,
				},
			},
		});

		if($(".header__anuncio").length > 0){
			const headerAnnouncements = new Swiper(".header__anuncio", {
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
					pauseOnMouseEnter: false,
				},
				loop: true,
				speed: 200,
				pagination: false
			});
		}

		loadComplementSwiper();
	});
})(jQuery);

function loadComplementSwiper()
{
	let swiper_complement = new Swiper(".swiper_complement", {
		autoplay: {
			enabled: true,
			delay: 4000,
			pauseOnMouseEnter: false,
			disableOnInteraction: true,
		},
		speed: 200,
		slidesPerView: 1,
		spaceBetween: 10,
		pagination: {
			el: ".swiper-pagination",
			type: "bullets",
			clickable: true,
		},
	});
}

